











import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator'
import InputWithValidation from '@/mixins/InputWithValidation'

@Component({
  components: {}
})
export default class VTextFieldWithValidation extends Mixins(InputWithValidation) {
}
